<template>
  <div v-if="banners?.length">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onChange">
      <van-swipe-item v-for="(item, index) in banners" :key="index" @click="toLink(item.jumpUrl)">
        <img :src="item.picUrl" alt="" class="img" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ banners.length }}</div>
      </template>
    </van-swipe>
  </div>
  <div v-else class="my-swipe">
    <img class="img" :src="picUrl" alt="">
  </div>
</template>
<script>
export default {
  name: 'Swiper',
  data() {
    return {
      current: 0
    }
  },
  props: {
    banners: Array,
    picUrl: String
  },
  methods: {
    onChange(index) {
      this.current = index
    },
    toLink(url) {
      if (!url?.length) return

      window.location.href = url
    }
  }
}
</script>
<style lang="less" scoped>
@media screen and (min-width: 1000px) {
  .my-swipe .van-swipe-item {
    height: calc(690px * 9 / 16) !important;
  }
  .img {
    height: calc(690px * 9 / 16) !important;
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 100vw / 2;
  text-align: center;
}
.img {
  width: 100%;
  height: 100vw / 2;
  // border-radius: 4px;
}
.custom-indicator {
  width: 44px;
  height: 20px;
  position: absolute;
  right: 16px;
  bottom: 16px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 13px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
